import { use, useEffect, useState } from 'react';
import { Modal, Button, Form, Input, message, Divider, Select, Switch } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { NumericFormat } from 'react-number-format';
import axios from "./../../services/http";

const ModalEditarPresupuestoCmp = ({ openModalBudget, cancelModalBudgetDialog, reloadData, cp, contratista }) => {

    const [editBudgetForm] = Form.useForm();
    const [disabledIVA, setDisabledIVA] = useState(false);
    const [anticipo, setAnticipo] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (cp && contratista) {
            editBudgetForm.setFieldsValue({
                cp_id: cp.id,
                obra_id: cp.obra_id,
                concepto: cp.concepto,
                descripcion: cp.descripcion,
                importe: cp.importe,
                contratista_id: cp.contratista_id,
                contratista: contratista,
            });
        }
    }, [cp, contratista]);

    const onValuesChange = (changedValues) => {
        if ('presupuestoIva' in changedValues) {
          const restante = 100 - parseFloat(changedValues.presupuestoIva || 0);
          editBudgetForm.setFieldsValue({ presupuestoNoIva: restante.toFixed(2) });
          if (restante === 100 || restante === 100.00) {
            editBudgetForm.setFieldsValue({ iva: 0 });
            editBudgetForm.setFieldValue({ anticipoFiscal: 0 });
            setDisabledIVA(true);
          } else if (restante >= 0) {
            editBudgetForm.setFieldsValue({ iva: null });
            setDisabledIVA(false);
          }
        }
        if ('presupuestoNoIva' in changedValues) {
          const restante = 100 - parseFloat(changedValues.presupuestoNoIva || 0);
          editBudgetForm.setFieldsValue({ presupuestoIva: restante.toFixed(2) });
          if ((restante === 0||restante === 0.00) || restante < 0) {
            editBudgetForm.setFieldsValue({ iva: null });
            setDisabledIVA(true);
          } else {
            editBudgetForm.setFieldsValue({ iva: null });
            setDisabledIVA(false);
          }
        }
    };

    const handleEditBudget = async (values) => {
        
        setLoading(true);
        const HistoricalCP = {
            cp_id: cp.id,
            obra_id: cp.obra_id,
            contratista_id: cp.contratista_id,
            concepto: values.concepto,
            descripcion: values.descripcion,
            presupuesto: (typeof values.presupuesto === "string" ? parseFloat(values.presupuesto.replace(/[$,]/g,'')).toFixed(2) : values.presupuesto),
            presupuesto_iva: values.presupuestoIva,
            presupuesto_no_iva: values.presupuestoNoIva,
            iva: (values.iva !== undefined ? values.iva : 0)
        };

        const response = await axios.HTTP_POST("/api/v1/cp/historical/save", HistoricalCP);
        if (response) {
            setLoading(false);
            message.success(response.data.message);
            reloadData();
        }
    }

    return (
        <>
            <Modal
                title={`Editar control de pago - (${cp?.concepto})`}
                open={openModalBudget}
                onCancel={cancelModalBudgetDialog}
                footer={null}
                >
                <Form
                    form={editBudgetForm}
                    layout="vertical"
                    onFinish={handleEditBudget}
                    onValuesChange={onValuesChange}
                >
                    <Divider style={{ margin: '24px 0' }} />
                    <Form.Item
                        label="Contratista"
                        name="contratista"
                     >
                        <Input disabled />
                    </Form.Item>
                    <Form.Item
                        label="Concepto"
                        name="concepto"
                     >
                        <Input disabled />
                    </Form.Item>
                     <Form.Item
                        label="Descripción"
                        name="descripcion"
                     >
                        <Input disabled />
                    </Form.Item>
                    <Form.Item
                        label="Presupuesto Inicial"
                        name="presupuesto"
                        rules={[{ required: true, message: 'Por favor ingresa el presupuesto inicial' }]}
                    >
                        <NumericFormat 
                            thousandSeparator={true} prefix={'$ '} 
                            customInput={Input}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Presupuesto con IVA (%)"
                        name="presupuestoIva"
                        rules={[{ required: true, message: 'Por favor ingresa el presupuesto con IVA' }]}
                    >
                        <Input type="number" />
                    </Form.Item>
                    <Form.Item
                        label="Presupuesto sin IVA (%)"
                        name="presupuestoNoIva"
                        rules={[{ required: true, message: 'Por favor ingresa el presupuesto sin IVA' }]}
                    >
                        <Input type="number" />
                    </Form.Item>
                    {!disabledIVA?
                        <Form.Item
                            label="IVA"
                            name="iva"
                            rules={[{ required: true, message: 'Por favor selecciona el IVA' }]}
                        >
                            <Select placeholder="Selecciona una opción" disabled={disabledIVA}>
                                <Select.Option value={8}>8%</Select.Option>
                                <Select.Option value={16}>16%</Select.Option>
                            </Select>
                        </Form.Item>
                    :null}
                    {/* <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <Form.Item
                            name="anticipo">
                            <Switch onChange={onChange} /> Anticipo
                        </Form.Item>
                    </div> */}
                    {/* {anticipo && (
                        <>
                            {!disabledIVA ?
                                <Form.Item
                                    label="Anticipo fiscal"
                                    name="anticipoFiscal"
                                    rules={[
                                        { required: true, message: 'Por favor ingresa el anticipo fiscal' },
                                        {
                                            validator: (_, value) => {
                                                const anticipoFiscal = toNumber(value);
                                                const anticipoNoFiscal = toNumber(editBudgetForm.getFieldValue("anticipoNoFiscal"));
                                                const presupuesto = toNumber(editBudgetForm.getFieldValue("presupuesto"));

                                                if (anticipoFiscal + anticipoNoFiscal > presupuesto) {
                                                    return Promise.reject("La suma de anticipos no puede ser mayor al presupuesto.");
                                                }

                                                return Promise.resolve();
                                            },
                                        },
                                    ]}
                                >
                                    <NumericFormat 
                                        thousandSeparator={true} prefix={'$ '} 
                                        customInput={Input}
                                    />
                                </Form.Item>
                            :null}
                            
                            <Form.Item
                                label="Anticipo no fiscal"
                                name="anticipoNoFiscal"
                                rules={[
                                    { required: true, message: 'Por favor ingresa el anticipo no fiscal' },
                                    {
                                        validator: (_, value) => {
                                            const anticipoFiscal = toNumber(editBudgetForm.getFieldValue("anticipoFiscal"));
                                            const anticipoNoFiscal = toNumber(value);
                                            const presupuesto = toNumber(editBudgetForm.getFieldValue("presupuesto"));

                                            if ((anticipoFiscal + anticipoNoFiscal) > presupuesto) {
                                                return Promise.reject("La suma de anticipos no puede ser mayor al presupuesto.");
                                            }

                                            return Promise.resolve();
                                        },
                                    },
                                ]}
                            >
                                <NumericFormat 
                                    thousandSeparator={true} prefix={'$ '} 
                                    customInput={Input}
                                />
                            </Form.Item>
                        </>
                    )} */}

                    <Divider style={{ margin: '24px 0' }} />

                    <Form.Item>
                        <div style={{ display: 'flex', justifyContent: 'end', gap: '10px' }}>
                            <Button onClick={cancelModalBudgetDialog} style={{ marginRight: 8 }}>
                                Cancelar
                            </Button>
                            <Button type="primary" htmlType="submit">
                                <SaveOutlined /> Guardar
                            </Button>
                        </div>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default ModalEditarPresupuestoCmp;